export enum BehavioralAction {
  Did = `did`,
  DidNot = `did not do`,
}
